import React, { createContext, useContext, useState } from 'react';
import { Toast, ToastsPortal } from '@hiiretail/synergy-ui';
import styled from 'styled-components';

type NotificationsContextType = {
  showNotification: (content: string | React.ReactElement, delay?: number) => void;
};

const StyledToast = styled(Toast)`
  max-width: 350px;
  span {
    line-height: unset;
  }
  button {
    padding: 0;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const NotificationsContext = createContext<NotificationsContextType>(undefined!);

export const NotificationsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [toastsList, setToastsList] = useState<
    { children: string | React.ReactElement; autoHideDelay: number; id: string }[]
  >([]);

  const generateId = () => `${Math.random().toString(36).substr(2, 15)}`;

  const onHideToast = (id: string) => {
    setToastsList(toastsList.filter(({ id: toastId }) => toastId !== id));
  };

  const addToast: NotificationsContextType['showNotification'] = (content, delay?) => {
    const nextToast = { children: content, autoHideDelay: delay || 5000, id: generateId() };
    setToastsList([...toastsList, nextToast]);
  };

  return (
    <NotificationsContext.Provider value={{ showNotification: addToast }}>
      <ToastsPortal />
      {toastsList.map(({ children, autoHideDelay, id }) => (
        <StyledToast onHide={() => onHideToast(id)} autoHideDelay={autoHideDelay} key={id}>
          {children}
        </StyledToast>
      ))}
      {children}
    </NotificationsContext.Provider>
  );
};

type UseNotifications = () => NotificationsContextType;

export const useNotifications: UseNotifications = () => useContext(NotificationsContext);
